import React, { Fragment, ReactElement } from 'react';
import { View } from 'react-native';
import { Popout, PopoutProps } from 'src/components/Popout';
import { ScaleIntro } from 'src/components/Animated';
import { Title3, Caption1 } from 'src/components/Typography';
import { Separator } from 'src/components/Separator';
import { Interpose } from 'src/components/Interpose';
import useStyles from './Alert.styles';

export type AlertProps = PopoutProps & {
  type: 'horizontal' | 'vertical';
  title: string;
  description?: string;
  actions: Array<ReactElement>;
};

export const Alert: React.FC<AlertProps> = ({
  visible,
  type,
  title,
  description,
  actions,
  ...props
}) => {
  const s = useStyles();

  return (
    <Popout visible={visible} style={s.root} {...props}>
      <ScaleIntro style={[s.alert]} visible={visible}>
        <View style={s.content}>
          <Title3 style={s.textIOS} weight="semibold">
            {title}
          </Title3>
          {description && (
            <Fragment>
              <Separator size="xs" />
              <Caption1 style={s.textIOS}>{description}</Caption1>
            </Fragment>
          )}
        </View>
        <View
          style={[
            type === 'horizontal' && s.actionsHorizontal,
            type === 'vertical' && s.actionsVertical,
          ]}
        >
          {type === 'horizontal' && (
            <Interpose separator={<View style={s.vhr} />}>{actions}</Interpose>
          )}
          {type === 'vertical' && actions}
        </View>
      </ScaleIntro>
    </Popout>
  );
};
